// **** import modules ****
import inView from "@@assets/scripts/inViewObserver";

// local modules
import { csl } from "@@assets/scripts/app";
import vuwer from "@@assets/scripts/vuwer";


// **** process ****
vuwer
.add("siteFooter", {
	selector: "#site_footer",
	
	onReady($self) {
		if(!$self) {
			csl.log.grey("no siteFooter.");
			return false;
		}
		
		$self.children(".content").each((i, elm) => {
			inView.addTarget(elm, ($elm, isIntersecting) => {
				if(isIntersecting) {
					csl.log.orange("footer content", "in view");
				} else {
					csl.log.gray("footer content", "out of view");
				}
			});
		});
	}
});
